import {Layout, Modal} from './components';
import {Routes, Route} from 'react-router-dom';
import {Provider} from 'react-redux';
import store from './app/store';
import { setupInterceptors } from './providers/apiClient';
import {
    CompaniesScreen,
    CompanyCreateScreen,
    ComplainsScreen,
    ConsumerEditScreen,
    ConsumersScreen,
    LoginScreen,
    UsersScreen,
    UserCreateScreen,
    UserEditScreen,
    SetPasswordScreen,
    RememberPasswordScreen,
    LogsScreen,
    SettingsScreen,
    ComplaintEditScreenV2 as ComplainEditScreen
} from './screens';
import './App.scss';
import {RequireAuth} from './components/auth';
import {useTranslation} from 'react-i18next';
import ReportsScreen from "./screens/reports.screen";
import {TimeZoneProvider} from "./providers/TimeZoneProvider";
import CompanyEditArrowScreen from "./screens/companyEditArrow.screen";
import AuthProvider from "./providers/AuthProvider";
import {CookiesProvider} from "react-cookie";

setupInterceptors(store);

function App() {
    const {t} = useTranslation('Pages')

    return (
        <CookiesProvider defaultSetOptions={{path: '/'}}>
            <AuthProvider>
                <TimeZoneProvider>
                    <Provider store={store}>
                        <Layout>
                            {/* <AutoLogout> */}
                            <Modal/>
                            <Routes>
                                <Route exact path={t('consumersLink')} element={
                                    <RequireAuth>
                                        <ConsumersScreen/>
                                    </RequireAuth>
                                }
                                />
                                <Route exact path={`${t('consumerLink')}:id`} element={
                                    <RequireAuth>
                                        <ConsumerEditScreen/>
                                    </RequireAuth>
                                }
                                />
                                <Route exact path={t('usersLink')} element={
                                    <RequireAuth>
                                        <UsersScreen/>
                                    </RequireAuth>
                                }
                                />
                                <Route exact path={t('userCreateLink')} element={
                                    <RequireAuth>
                                        <UserCreateScreen/>
                                    </RequireAuth>
                                }
                                />
                                <Route exact path={t('userLink')} element={
                                    <RequireAuth>
                                        <UserEditScreen/>
                                    </RequireAuth>
                                }
                                />
                                <Route exact path={t('complainsLink')} element={
                                    <RequireAuth>
                                        <ComplainsScreen/>
                                    </RequireAuth>
                                }
                                />
                                <Route exact path={`${t('complainLink')}:id`} element={
                                    <RequireAuth>
                                        <ComplainEditScreen/>
                                    </RequireAuth>
                                }
                                />
                                <Route exact path={t('companiesLink')} element={
                                    <RequireAuth>
                                        <CompaniesScreen />
                                    </RequireAuth>
                                }
                                />
                                <Route exact path={t('companyCreateLink')} element={
                                    <RequireAuth>
                                        <CompanyCreateScreen/>
                                    </RequireAuth>
                                }
                                />
                                <Route exact path={`${t('companyLink')}:id`} element={
                                    <RequireAuth>
                                        <CompanyEditArrowScreen/>
                                    </RequireAuth>
                                }
                                />
                                <Route exact path={t('loginLink')} element={
                                    <LoginScreen/>
                                }
                                />
                                <Route exact path={t('setPasswordLink')} element={
                                    <SetPasswordScreen/>
                                }
                                />
                                <Route exact path={t('rememberPasswordLink')} element={
                                    <RememberPasswordScreen/>
                                }
                                />
                                <Route exact path={t('logsLink')} element={
                                    <RequireAuth>
                                        <LogsScreen/>
                                    </RequireAuth>
                                }
                                />
                                <Route exact path={t('reportsLink')} element={
                                    <RequireAuth>
                                        <ReportsScreen/>
                                    </RequireAuth>
                                }
                                />
                                <Route exact path={"/settings"} element={
                                    <RequireAuth>
                                        <SettingsScreen/>
                                    </RequireAuth>
                                }
                                />
                            </Routes>
                            {/* </AutoLogout> */}
                        </Layout>
                    </Provider>
                </TimeZoneProvider>
            </AuthProvider>
        </CookiesProvider>
    );
}

export default App;
